module.exports = __webpack_public_path__ + "static/profile-pic-839b4b350f22ac240dd20efc9cf8af01.jpeg";